var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Modal from 'react-modal';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { ActionBlock, DismissText, TitleBlock, ModalContentWrapper, TitleIcon, } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@appspotr/ui-kit';
var CommonModal = function (_a) {
    var isVisible = _a.isVisible, setIsVisible = _a.setIsVisible, title = _a.title, _b = _a.cancelText, cancelText = _b === void 0 ? 'Cancel' : _b, modalBody = _a.modalBody, _c = _a.actionButtonContent, actionButtonContent = _c === void 0 ? 'Proceed' : _c, _d = _a.actionButtonOnClick, actionButtonOnClick = _d === void 0 ? function () { } : _d, _e = _a.isActionButtonDisabled, isActionButtonDisabled = _e === void 0 ? false : _e, _f = _a.actionButtonType, actionButtonType = _f === void 0 ? 'primary' : _f, _g = _a.showCloseButton, showCloseButton = _g === void 0 ? true : _g, _h = _a.showFooter, showFooter = _h === void 0 ? true : _h, _j = _a.titleBlockBorderBottom, titleBlockBorderBottom = _j === void 0 ? false : _j, cancelTextOnClick = _a.cancelTextOnClick, _k = _a.deleteModal, deleteModal = _k === void 0 ? false : _k, _l = _a.warningModal, warningModal = _l === void 0 ? false : _l, _m = _a.modalContentWrapperOverFlowVisible, modalContentWrapperOverFlowVisible = _m === void 0 ? false : _m;
    return (_jsx(Modal, __assign({ ariaHideApp: false, headerTitle: title, open: isVisible, onClose: function () {
            setIsVisible(false);
        }, isOpen: isVisible, onRequestClose: function () {
            setIsVisible(false);
        }, style: {
            content: {
                width: '560px',
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                borderRadius: '8px',
                padding: '0',
                border: '0',
                maxHeight: '100vh',
                overflow: 'visible',
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
            },
        } }, { children: _jsxs(_Fragment, { children: [_jsxs(TitleBlock, __assign({ borderBottom: titleBlockBorderBottom, deleteModal: deleteModal, warningModal: warningModal }, { children: [_jsx("div", { children: title }), showCloseButton && (_jsx(TitleIcon, __assign({ onClick: function () { return setIsVisible(false); } }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }) })))] })), _jsx(ModalContentWrapper, __assign({ modalContentWrapperOverFlowVisible: modalContentWrapperOverFlowVisible }, { children: modalBody })), showFooter && (_jsxs(ActionBlock, { children: [_jsx(DismissText, __assign({ onClick: cancelTextOnClick || (function () { return setIsVisible(false); }) }, { children: cancelText })), _jsx(Button, __assign({ type: actionButtonType, onClick: actionButtonOnClick, disabled: isActionButtonDisabled }, { children: actionButtonContent }))] }))] }) })));
};
export default CommonModal;
